/** ******** 全局公共接口  ********* */
//  获取所有地区
export const getDictList = {
  url: '/basic/area/provence/dict.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const uploadFile = {
  url: '/basic/uploadFile.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const uploadVideoFile = {
  url: '/basic/uploadVideoFile.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

export const getNoticeTypeList = {
  url: '/admin/information/getInformationType.json',
  method: 'get'
};

// 获取发货方下拉列表
export const getBranchList = {
  url: '/admin/branch/getBranchIdComboboxList.json',
  method: 'post'
};

// 获取项目列表
export const getProjectList = {
  url: '/admin/common/getProjectList.json',
  method: 'get'
};

// 公共异步下载方法
export const exportForAsync = {
  url: '/admin/importOrExportExcel/commonExportForAsync.json',
  method: 'post'
};

// 获取商品中心商品
export const getProdCenterData = {
  url: '/admin/businessProd/pageGoodsList',
  method: 'get'
};

// 平台服务费率保存
export const savePlatformServiceFee = {
  url: '/admin/split/rule/updatePlatformServiceFee.json',
  method: 'post',
  config: { headers: { 'Content-Type': 'multipart/form-data'}}
}